
const {
  updateAppliedGlitchesLists,
  updateSpriteList
} = require('./arcade-vm-hooks')


/**
 * Step the scratch vm.
 * @module store/utils/game-step
 */

/**
 * Steps the given vm.  We use a custom build of scratch-vm in
 * externals/scratch-vm.js which exposes the private _step() function
 *
 * @param {object} gamebenderVM
 */
function gameStep (gamebenderVM, glitchApplications) {
  updateSpriteList(gamebenderVM)
  updateAppliedGlitchesLists(gamebenderVM, glitchApplications)
  gamebenderVM.runtime.targets.forEach(t => {
    t.getBounds()
  })

  // Step the machine
  gamebenderVM.runtime._step()
  return gamebenderVM
}

module.exports = gameStep
